{
  "version": 1,
  "asset_id": "8135a941-faf8-48a1-90d0-81b18a2e1d09",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8135a941-faf8-48a1-90d0-81b18a2e1d09/sleeve-amateur-1-220.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8135a941-faf8-48a1-90d0-81b18a2e1d09/sleeve-amateur-1-220.jpg",
  "original_filename": "sleeve-amateur-1-220.jpg",
  "size": 8066,
  "content_type": "image/jpeg",
  "created_at": "2026-09-29T01:15:54Z"
}
